import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-base pt-8" }
const _hoisted_2 = { class: "overflow-hidden rounded-xl bg-white shadow relative" }
const _hoisted_3 = { class: "absolute top-5 right-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", { class: "mr-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1040_5920)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M10.0001 13.3334V10.0001M10.0001 6.66675H10.0084M18.3334 10.0001C18.3334 14.6025 14.6025 18.3334 10.0001 18.3334C5.39771 18.3334 1.66675 14.6025 1.66675 10.0001C1.66675 5.39771 5.39771 1.66675 10.0001 1.66675C14.6025 1.66675 18.3334 5.39771 18.3334 10.0001Z",
        stroke: "#98A2B3",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1040_5920" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_5 = { class: "absolute z-10 p-2 shadow-sm bg-[#101828] text-sm text-white p-3 top-0 -left-[305px] rounded-md w-[300px]" }
const _hoisted_6 = { class: "px-4 py-5 sm:p-6" }
const _hoisted_7 = { class: "-ml-4 -mt-2 flex flex-wrap items-center justify-between sm:flex-nowrap" }
const _hoisted_8 = { class: "ml-4 mt-2" }
const _hoisted_9 = { class: "text-lg font-semibold leading-6 text-primary" }
const _hoisted_10 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass([
          'mt-5',
          'grid',
          'grid-cols-1',
          'overflow-hidden',
          'md:grid-cols-7',
        ])
}
const _hoisted_11 = { class: "text-sm font-normal text-tertiary" }
const _hoisted_12 = { class: "mt-1 flex items-center md:block lg:flex pt-2" }
const _hoisted_13 = { class: "flex items-baseline text-2xl font-semibold pr-4" }
const _hoisted_14 = { class: "flex items-baseline text-xs text-tertiary font-medium md:mt-2 lg:mt-0 pt-2" }
const _hoisted_15 = { class: "text-base pt-8" }
const _hoisted_16 = { class: "flex gap-5 justify-between align" }
const _hoisted_17 = { class: "flex flex-col w-full justify-between gap-3" }
const _hoisted_18 = { class: "w-full h-full bg-white rounded-xl p-5 shadow-journeys relative" }
const _hoisted_19 = { class: "flex w-full items-center justify-between mb-4" }
const _hoisted_20 = { class: "text-primary font-medium text-lg flex items-center" }
const _hoisted_21 = { class: "absolute top-5 right-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("button", { class: "mr-1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_1040_5920)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M10.0001 13.3334V10.0001M10.0001 6.66675H10.0084M18.3334 10.0001C18.3334 14.6025 14.6025 18.3334 10.0001 18.3334C5.39771 18.3334 1.66675 14.6025 1.66675 10.0001C1.66675 5.39771 5.39771 1.66675 10.0001 1.66675C14.6025 1.66675 18.3334 5.39771 18.3334 10.0001Z",
        stroke: "#98A2B3",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_1040_5920" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_23 = { class: "absolute z-10 p-2 shadow-sm bg-[#101828] text-sm text-white p-3 top-0 -left-[305px] rounded-md w-[300px]" }
const _hoisted_24 = ["value"]

import { ref, watch } from "vue";
import {
  ArrowDownIcon,
  ArrowUpIcon,
  LockClosedIcon,
} from "@heroicons/vue/20/solid";
import StackedBarComponent from "../components/JourneysBarGraphComponent.vue";
import { useMasteryStore } from "@/stores/masteryStore";
import { useFilterStore } from "@/stores/filterStore";
import { useI18n } from "vue-i18n";
import {
  StudentProgress
} from "@/interfaces/mastery.interface";
import PageHeaderComponent from "@/components/global/PageHeaderComponent.vue";
import FiltersOutOfDateComponent from "@/modules/main/components/FiltersOutOfDateComponent.vue";
import LoadingSpinnerComponent from "@/modules/main/components/LoadingSpinnerComponent.vue";

import moment from "moment";

export default /*#__PURE__*/_defineComponent({
  __name: 'JourneysView',
  setup(__props) {

const startDate = ref(moment().subtract(90, 'days').toDate());
const endDate = ref(new Date());

const { t } = useI18n();

const masteryStore = useMasteryStore();
const filterStore = useFilterStore();

const threads = (): { threadId: number; threadName: string }[] => {
  if (filterStore.selectedSubject.name == "English") {
    return [
      {
        threadId: 1,
        threadName: t("global.thread_names.english.visual_communication"),
      },
      {
        threadId: 2,
        threadName: t("global.thread_names.english.oral_comprehension"),
      },
      {
        threadId: 3,
        threadName: t("global.thread_names.english.written_comprehension"),
      },
      {
        threadId: 4,
        threadName: t("global.thread_names.english.language_structure"),
      },
    ];
  }

  return [
    { threadId: 1, threadName: t("global.thread_names.maths.numbers") },
    { threadId: 2, threadName: t("global.thread_names.maths.fractions") },
    { threadId: 3, threadName: t("global.thread_names.maths.measurements") },
    { threadId: 4, threadName: t("global.thread_names.maths.data_literacy") },
    { threadId: 5, threadName: t("global.thread_names.maths.problem_solving") },
    {
      threadId: 6,
      threadName: t("global.thread_names.maths.patterns_algebra"),
    },
    { threadId: 7, threadName: t("global.thread_names.maths.space_shape") },
  ];
};

const threadName = (threadId: number) => {
  if (threads().find((thread) => thread.threadId === threadId)) {
    const thread = threads().find((thread) => thread.threadId === threadId);
    if (thread) {
      return thread.threadName;
    } else {
      return "";
    }
  } else {
    return "";
  }
};

const selectedThread = ref({
  threadId: 1,
  threadName: t("global.thread_names.maths.numbers"),
});

// Add in a watch to check for when subject changes and new data comes back to set the selected thread to the first thread
watch(
  () => filterStore.selectedSubject,
  () => {
    selectedThread.value = threads()[0];
  }
);

const expectedLevelThreads = (): StudentProgress[] => {
  const data = masteryStore.getStudentProgressData;
  if (Array.isArray(data)) {
    return data;
  } else {
    return [];
  }
};


return (_ctx: any,_cache: any) => {
  const _component_tooltip = _resolveComponent("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageHeaderComponent, {
      pageHeading: _ctx.$t('journey_view.header')
    }, null, 8, ["pageHeading"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_tooltip, null, {
            trigger: _withCtx(() => [
              _hoisted_4
            ]),
            tooltip: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("journey_view.tooltips.student_at_expected_level")), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h3", _hoisted_9, _toDisplayString(_ctx.$t("journeys_view.students_at_expected_level")), 1)
            ])
          ]),
          _createVNode(LoadingSpinnerComponent),
          _createVNode(FiltersOutOfDateComponent),
          (_unref(masteryStore).loader.fetchStudentProgressData === false)
            ? (_openBlock(), _createElementBlock("dl", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expectedLevelThreads(), (thread, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "pr-4"
                  }, [
                    _createElementVNode("dt", _hoisted_11, _toDisplayString(threadName(thread.threadId)), 1),
                    _createElementVNode("dd", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, _toDisplayString(Math.round(thread.percentageAtExpectedLevel)) + "% ", 1),
                      _createElementVNode("div", {
                        class: _normalizeClass([
                thread.percentageImproving > 0
                  ? 'bg-green-100 text-green-800'
                  : thread.percentageImproving === 0
                    ? 'bg-gray-100 text-gray-800'
                    : 'bg-red-100 text-red-800',
                'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium md:mt-2 lg:mt-0',
              ])
                      }, [
                        (thread.percentageImproving > 0)
                          ? (_openBlock(), _createBlock(_unref(ArrowUpIcon), {
                              key: 0,
                              class: "-ml-1 mr-0.5 h-3 w-3 flex-shrink-0 self-center text-green-500",
                              "aria-hidden": "true"
                            }))
                          : (thread.percentageImproving === 0)
                            ? (_openBlock(), _createBlock(_unref(LockClosedIcon), {
                                key: 1,
                                class: "-ml-1 mr-0.5 h-3 w-3 flex-shrink-0 self-center text-gray-500",
                                "aria-hidden": "true"
                              }))
                            : (_openBlock(), _createBlock(_unref(ArrowDownIcon), {
                                key: 2,
                                class: "-ml-1 mr-0.5 h-3 w-3 flex-shrink-0 self-center text-red-500",
                                "aria-hidden": "true"
                              })),
                        _createTextVNode(" " + _toDisplayString(Math.round(thread.percentageImproving)) + "% ", 1)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", null, _toDisplayString(thread.numberAtExpectedLevel), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("journeys_view.students")), 1)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h1", _hoisted_20, [
                _createTextVNode(_toDisplayString(_ctx.$t("journeys_view.current_mastery")) + " ", 1),
                _createElementVNode("span", null, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_tooltip, null, {
                      trigger: _withCtx(() => [
                        _hoisted_22
                      ]),
                      tooltip: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("journey_view.tooltips.current_mastery")), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createVNode(LoadingSpinnerComponent),
              _createVNode(FiltersOutOfDateComponent),
              (_unref(masteryStore).loader.fetchAssessmentMasteryData === false)
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 0,
                    id: "small",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedThread).value = $event)),
                    class: "block rounded-md border-0 py-1.5 text-primary shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-[#155EEF] sm:max-w-xs sm:text-sm sm:leading-6 mr-8"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(threads(), (thread, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: index,
                        value: thread
                      }, _toDisplayString(thread.threadName), 9, _hoisted_24))
                    }), 128))
                  ], 512)), [
                    [_vModelSelect, selectedThread.value]
                  ])
                : _createCommentVNode("", true)
            ]),
            (selectedThread.value)
              ? (_openBlock(), _createBlock(StackedBarComponent, {
                  key: 0,
                  thread: selectedThread.value
                }, null, 8, ["thread"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})